/**
 * Do not edit directly, this file was auto-generated.
 */

export const ColorTextPrimary = "#FFFFFF";
export const ColorTextSecondary = "#1A1A1A";
export const ColorBackgroundPrimary = "#0064FE";
export const ColorBackgroundSecondary = "#DAEBFF";
export const ColorIconPrimary = "#1A1A1A";
export const ColorIconSecondary = "#1A1A1A";
export const ColorBorderPrimary = "#3285F9";
export const ColorBorderSecondary = "#C5DFFF";
